import { isCustomer as checkIsCustomer, isThirdParty as checkIsThirdParty } from "le-coffre-resources/dist/MemberTypes";

export interface StepEmailRoleResolutionInput {
	userType?: string | null;
	globalRole?: string | null;
	lastKnownRoleFromSession: string;
	customerConnected: boolean;
}

export function resolveStepEmailRoleFlags(input: StepEmailRoleResolutionInput): {
	isCustomer: boolean;
	isThirdParty: boolean;
	isNotary: boolean;
} {
	const normalizedUserType = input.userType?.toLowerCase() ?? "";
	const normalizedGlobalRole = input.globalRole?.toLowerCase() ?? "";
	const lastKnownRole = input.lastKnownRoleFromSession.toLowerCase();
	const effectiveRole = normalizedUserType || normalizedGlobalRole || lastKnownRole;

	const isCustomer = checkIsCustomer(effectiveRole) || input.customerConnected;
	const isThirdParty = checkIsThirdParty(effectiveRole);
	const isNotary = !isCustomer && !isThirdParty;

	return { isCustomer, isThirdParty, isNotary };
}
